export default {
  operationalMetricCriteria: {
    name: 'operationalMetricCriteria',
    type: 'OperationalMetricesRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
  overviewMetricCriteria: {
    name: 'overviewMetricCriteria',
    type: 'OverviewMetricesRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
  psdCriteria: {
    name: 'psdCriteria',
    type: 'PsdMetricsRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
  mctCriteria: {
    name: 'mctCriteria',
    type: 'MCTMetricsRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
  nbaCriteria: {
    name: 'nbaCriteria',
    type: 'NBAMetricsRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
  applicationMetricCriteria: {
    name: 'applicationMetricCriteria',
    type: 'ApplicationMetricsRequestDTOInput!',
    params: [
      'selectedProgram',
      'selectedProduct',
      'selectedSector',
      'selectedMarket',
      'startUTCDate',
      'endUTCDate',
      'ytdCheckbox',
      'selectedCustomer',
    ],
    filterFunction: (filter) => {
      return {
        programId: filter.programId,
        productId: filter.productId,
        sectorId: filter.sectorId,
        marketId: filter.marketId,
        startDate: filter.startDate,
        endDate: filter.endDate,
        year: filter.year,
        customerId: filter.customerId,
      };
    },
    paramFunction: (data) => {
      const {
        selectedProgram,
        selectedProduct,
        selectedSector,
        selectedMarket,
        startUTCDate,
        endUTCDate,
        ytdCheckbox,
        selectedCustomer,
      } = data;

      return {
        programId: selectedProgram?.programId || 1,
        productId: selectedProduct?.productId || 1,
        sectorId: selectedSector?.sectorId || 1,
        marketId: selectedMarket?.marketId || null,
        startDate: startUTCDate,
        endDate: endUTCDate,
        year: ytdCheckbox ? new Date(startUTCDate).getUTCFullYear() : null,
        customerId: selectedCustomer?.id || null,
      };
    },
  },
};
